import { Instagram as InstagramIcon } from 'lucide-react'

export default function Instagram() {
  return (
    <section id="connect" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center max-w-2xl mx-auto">
          <p
            className="text-sm font-medium tracking-[0.2em] uppercase mb-4"
            style={{ color: 'var(--color-gold)' }}
          >
            Stay Connected
          </p>

          <h2
            className="font-heading text-4xl md:text-5xl mb-6"
            style={{ color: 'var(--color-dark)' }}
          >
            Follow the Journey
          </h2>

          <p
            className="text-base md:text-lg leading-relaxed mb-10"
            style={{ color: 'var(--color-dark-light)' }}
          >
            Join our community on Instagram for daily inspiration, class updates,
            and behind-the-scenes moments from the mat.
          </p>

          {/* Instagram CTA */}
          <a
            href="https://www.instagram.com/omwithmadi/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 group"
          >
            <span
              className="p-4 rounded-full transition-colors"
              style={{ backgroundColor: 'var(--color-cream)' }}
            >
              <InstagramIcon
                size={28}
                style={{ color: 'var(--color-dark)' }}
              />
            </span>
            <span
              className="text-lg font-medium group-hover:underline underline-offset-4"
              style={{ color: 'var(--color-dark)' }}
            >
              @omwithmadi
            </span>
          </a>

        </div>
      </div>
    </section>
  )
}
